import { registerPlugin } from '@capacitor/core';
import { configureNativeAdBridge } from './native-ads/native-ad-feed';
const nativeAdBridge = registerPlugin('AdMob', {
    web: () => import('./web').then((m) => new m.AdMobWeb()),
});
const AdMob = nativeAdBridge;
configureNativeAdBridge(nativeAdBridge);
export * from './definitions';
export * from './banner/index';
export * from './interstitial/index';
export * from './reward-interstitial/index';
export * from './reward/index';
export * from './consent/index';
export * from './shared/index';
export * from './app-open/index';
export * from './native-ads/index';
export { AdMob };
//# sourceMappingURL=index.js.map